import { faArrowsRotate } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Tooltip } from "@/components/Tooltip/Tooltip";

/**
 * The score badge while lead scoring is queued for that lead (PREC-4076).
 *
 * Same grey circle as the rest of the score pills so the column never changes shape, with a turning
 * glyph rather than a static one: a re-score is charged and then handed to a worker, and until this
 * existed the table kept showing the previous P1/P2/P3/DQ — a queued re-score and one that silently
 * did nothing looked identical.
 */
export const ScoringPendingBadge = ({ label }: { label?: string }) => (
	<Tooltip content={label ?? "Lead Scoring in progress"}>
		<div
			className="w-[24px] h-[24px] bg-border-light rounded-full justify-center items-center flex"
			data-testid="scoring-pending-badge"
		>
			<Icon className="text-text-disabled w-6 h-6 p-1 animate-spin" icon={faArrowsRotate} />
		</div>
	</Tooltip>
);
